import { ref } from "vue";

const showDownloadAllDialog = ref(false);

export function useDownloadAllDialog() {
  return {
    showDownloadAllDialog,
  };
}
